import { Outlet } from 'react-router-dom';

function DeveloperSettings() {
  return <Outlet />;
}

export default DeveloperSettings;